













































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import * as _ from 'lodash';
import * as $ from 'jquery';

import { AbstractItemModel } from '@/models/items/abstract-item-model';
import { ListModel, ListItemEntry } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';

import { UserModule } from '@/store/modules/user';

import { BaseListView } from '@/views/BaseListView';
import OwnerItemCard from '@/components/item-cards/OwnerItemCard.vue';
import ListDetailFooter from '@/components/ListDetailFooter.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import { ItemModelUtil } from '../model-utils/item-model-util';

import { SwipeList, SwipeOut } from 'vue-swipe-actions';
import 'vue-swipe-actions/dist/vue-swipe-actions.css';

import InlineAddItem from '@/components/add-flows/InlineAddItem.vue';

import { IFRAMELY_API_KEY } from '@/secrets';

import { GenericItem } from '@/models/items/generic-item-model';

import firebase from 'firebase/app';
import 'firebase/functions';

@Component({
  components: {
    SwipeList,
    SwipeOut,
    OwnerItemCard,
    ListDetailFooter,
    UserAvatar,
    InlineAddItem
  }
})
export default class ListOwnerView extends BaseListView {
  itemsLoaded = false;
  itemToDelete: AbstractItemModel = null;
  overflowOpenId: string = null;
  swipeOpenItemIds: string[] = [];
  urlInput: string = '';
  urlMetadata: any = null;
  item: AbstractItemModel = new GenericItem();
  loadingUrl = false;

  closeAllOverflows() {
    this.overflowOpenId = null;
    // @ts-ignore
    $('.menuOpen')
      .removeClass('menuOpen')
      .attr(
        'style',
        'display: none; opacity: 0; transform: translate3d(0px, 100%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;'
      );
  }

  showOverflowMenu(item: AbstractItemModel) {
    if (this.overflowOpenId == item.id) {
      this.closeAllOverflows();
      return;
    }

    this.closeAllOverflows();
    this.overflowOpenId = item.id;
    // @ts-ignore
    $(`.container__overflow-menu[data-item-id='${item.id}']`)
      .addClass('menuOpen')
      .attr(
        'style',
        'display: block; opacity: 1; transform: translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;'
      );
  }

  swipeOpened(item: AbstractItemModel, dir: string) {
    if (dir == 'left') {
      this.swipeOpenItemIds.push(item.id);
    } else {
      this.swipeOpenItemIds = this.swipeOpenItemIds.filter(i => i !== item.id);
    }
  }

  isRevealed(item: AbstractItemModel): boolean {
    return this.swipeOpenItemIds.indexOf(item.id) > -1;
  }

  onListLoaded() {
    document.title = `mixlet: ${this.list.title} - ${this.list.username}`;
    this.loadItems();
  }

  onItemsLoaded() {
    this.itemsLoaded = true;
  }

  moveArrayItem(array: any[], from: number, to: number): any[] {
    return array.splice(to, 0, array.splice(from, 1)[0]);
  }

  moveItemRelative(item: AbstractItemModel, delta: number) {
    const oldList = _.clone(this.list);
    const index = _.findIndex(this.items, i => i.id == item.id);
    this.moveArrayItem(this.items, index, index + delta);
    this.list.itemEntries = this.items.map(i => ListItemEntry.fromItemId(i.id));
    this.list.images = this.items.filter(i => i.imageURL).map(i => i.imageURL);
    this.closeAllOverflows();
    ListModelUtil.updateList({
      oldList,
      list: this.list,
      shouldUpdateModifiedTime: false,
      user: UserModule.userProfile
    });
  }

  deleteItem() {
    this.list.itemEntries = this.list.itemEntries.filter(
      i => i.itemId !== this.itemToDelete.id
    );
    this.items = this.items.filter(i => i.id !== this.itemToDelete.id);
    ItemModelUtil.deleteItem({
      items: this.items,
      listId: this.list.id,
      item: this.itemToDelete
    });
    this.hideDeleteConfirmModal();
    this.closeAllOverflows();
  }

  showDeleteConfirmModal(item: AbstractItemModel) {
    this.itemToDelete = item;
    // @ts-ignore
    $('.modal__confirmation').show();
  }

  hideDeleteConfirmModal() {
    // @ts-ignore
    $(`.modal__confirmation`).hide();
  }

  async onUrlEnter() {
    this.loadingUrl = true;
    const getMetadata = firebase.functions().httpsCallable('app/getMetadata');
    const metadata = await getMetadata({ url: this.urlInput });
    console.log(metadata);
    this.urlMetadata = metadata.data;
    this.loadingUrl = false;


    // const iframelyUrl = `https://iframe.ly/api/iframely?url=${encodeURIComponent(
    //   this.urlInput
    // )}&api_key=${IFRAMELY_API_KEY}`;
    // const response = await fetch(iframelyUrl);
    // this.urlMetadata = await response.json();
    // console.log(this.urlMetadata);
    // this.item.title = this.urlMetadata.meta.title;
    // this.item.description = this.urlMetadata.meta.description;
  }

  onItemSaved() {
    this.loadList();
    console.log('item saved');
    this.item = new GenericItem().makeDummy();
    this.urlInput = '';
    this.urlMetadata = null;
  }
}
